import {forwardRef, useEffect, useMemo, useState} from "react";
import classNames from "classnames";

import {ManualPopover} from "@pg-design/floating-module";
import {Range, RangeColorVariant} from "@pg-design/range-module";

import {ISliderWithRangeProps} from "../../types/ISliderWithRangeProps";
import {IRange} from "../input_range/create_range";
import {RangeInput} from "../range_input/RangeInput";

import * as cns from "./SliderWithRange.module.css";

export const SliderWithRange = forwardRef<HTMLDivElement, ISliderWithRangeProps>((props, forwardedRef) => {
    const {name, value, min, max, step, ...rangeProps} = props;
    const lower = useMemo(() => parseInt(value.lower.toString()), [value]);
    const upper = useMemo(() => parseInt(value.upper.toString()), [value]);
    const [displayValues, setDisplayValues] = useState<IRange<number>>({lower, upper});
    const [warning, setWarning] = useState<{isOpen: boolean; message: string | null}>({isOpen: false, message: ""});

    useEffect(() => {
        props.onChange(name, displayValues);
    }, [displayValues]);

    const setValues = (inputValues: IRange<number>) => {
        if (inputValues.lower < min) {
            setWarning({
                isOpen: true,
                message: `Zakres dolny nie może być mniejszy niż ${min}${props.name === "area" ? ` m2` : ""}`
            });
        }
        if (inputValues.upper > max) {
            setWarning({
                isOpen: true,
                message: `Zakres górny nie może być większy niż ${max}${props.name === "area" ? ` m2` : ""}`
            });
        }
        if (inputValues.upper < lower) {
            setWarning({isOpen: true, message: "Zakres górny nie może być mniejszy od dolnego"});
        }
        if (inputValues.lower > upper) {
            setWarning({isOpen: true, message: "Zakres dolny nie może być większy od górnego"});

            if (inputValues.lower > max) {
                setDisplayValues({...displayValues, lower: displayValues.upper});
                return;
            }
        }
        if (warning.isOpen && inputValues.lower <= inputValues.upper && inputValues.upper <= max) {
            setWarning({isOpen: false, message: null});
        }

        setDisplayValues(inputValues);
    };

    return (
        <div className={classNames(cns.sliderWithRangeInputsWrapper)}>
            <div className={classNames("slider-with-range-slider-wrapper")}>
                <Range
                    name={`${name}_slider`}
                    value={displayValues}
                    onChange={(_name, value) => {
                        const newValues = {upper: parseInt(value.upper?.toString() || "0"), lower: parseInt(value.lower?.toString() || "0")};
                        setValues(newValues);
                    }}
                    step={step}
                    min={min}
                    max={max}
                    hideLabels
                    useDynamicChange
                    colorVariant={RangeColorVariant.LAVENDER}
                />
            </div>

            <ManualPopover
                popover={warning.message}
                isOpen={warning.isOpen}
                type="warning"
                handleSetIsOpen={(isWarningOpen) => {
                    setWarning({isOpen: isWarningOpen, message: warning.message});
                }}
            >
                {({refs, getReferenceProps}) => (
                    <div ref={refs.setReference} {...getReferenceProps()} className={classNames("slider-with-range-range-wrapper")}>
                        <RangeInput
                            ref={forwardedRef}
                            {...rangeProps}
                            name={`${name}_range`}
                            value={displayValues}
                            onChange={(_, value) => {
                                const convertedValues = {
                                    upper: parseInt(value.upper.toString()),
                                    lower: parseInt(value.lower.toString())
                                };
                                setValues(convertedValues);
                            }}
                            rightElement={props.inputsRightElement}
                        />
                    </div>
                )}
            </ManualPopover>
        </div>
    );
});
import {forwardRef, useEffect, useMemo, useState} from "react";
import classNames from "classnames";

import {ManualPopover} from "@pg-design/floating-module";
import {Range, RangeColorVariant} from "@pg-design/range-module";

import {ISliderWithRangeProps} from "../../types/ISliderWithRangeProps";
import {IRange} from "../input_range/create_range";
import {RangeInput} from "../range_input/RangeInput";

import * as cns from "./SliderWithRange.module.css";

export const SliderWithRange = forwardRef<HTMLDivElement, ISliderWithRangeProps>((props, forwardedRef) => {
    const {name, value, min, max, step, ...rangeProps} = props;
    const lower = useMemo(() => parseInt(value.lower.toString()), [value]);
    const upper = useMemo(() => parseInt(value.upper.toString()), [value]);
    const [displayValues, setDisplayValues] = useState<IRange<number>>({lower, upper});
    const [warning, setWarning] = useState<{isOpen: boolean; message: string | null}>({isOpen: false, message: ""});

    useEffect(() => {
        props.onChange(name, displayValues);
    }, [displayValues]);

    const setValues = (inputValues: IRange<number>) => {
        if (inputValues.lower < min) {
            setWarning({
                isOpen: true,
                message: `Zakres dolny nie może być mniejszy niż ${min}${props.name === "area" ? ` m2` : ""}`
            });
        }
        if (inputValues.upper > max) {
            setWarning({
                isOpen: true,
                message: `Zakres górny nie może być większy niż ${max}${props.name === "area" ? ` m2` : ""}`
            });
        }
        if (inputValues.upper < lower) {
            setWarning({isOpen: true, message: "Zakres górny nie może być mniejszy od dolnego"});
        }
        if (inputValues.lower > upper) {
            setWarning({isOpen: true, message: "Zakres dolny nie może być większy od górnego"});

            if (inputValues.lower > max) {
                setDisplayValues({...displayValues, lower: displayValues.upper});
                return;
            }
        }
        if (warning.isOpen && inputValues.lower <= inputValues.upper && inputValues.upper <= max) {
            setWarning({isOpen: false, message: null});
        }

        setDisplayValues(inputValues);
    };

    return (
        <div className={classNames(cns.sliderWithRangeInputsWrapper)}>
            <div className={classNames("slider-with-range-slider-wrapper")}>
                <Range
                    name={`${name}_slider`}
                    value={displayValues}
                    onChange={(_name, value) => {
                        const newValues = {upper: parseInt(value.upper?.toString() || "0"), lower: parseInt(value.lower?.toString() || "0")};
                        setValues(newValues);
                    }}
                    step={step}
                    min={min}
                    max={max}
                    hideLabels
                    useDynamicChange
                    colorVariant={RangeColorVariant.LAVENDER}
                />
            </div>

            <ManualPopover
                popover={warning.message}
                isOpen={warning.isOpen}
                type="warning"
                handleSetIsOpen={(isWarningOpen) => {
                    setWarning({isOpen: isWarningOpen, message: warning.message});
                }}
            >
                {({refs, getReferenceProps}) => (
                    <div ref={refs.setReference} {...getReferenceProps()} className={classNames("slider-with-range-range-wrapper")}>
                        <RangeInput
                            ref={forwardedRef}
                            {...rangeProps}
                            name={`${name}_range`}
                            value={displayValues}
                            onChange={(_, value) => {
                                const convertedValues = {
                                    upper: parseInt(value.upper.toString()),
                                    lower: parseInt(value.lower.toString())
                                };
                                setValues(convertedValues);
                            }}
                            rightElement={props.inputsRightElement}
                        />
                    </div>
                )}
            </ManualPopover>
        </div>
    );
});
